














import { Component, Vue } from "vue-property-decorator";
import { Circle2 } from "vue-loading-spinner";
import { fileDownload } from "@/file-utils";

import ShiftFilter from "@/layouts/DashboardLayoutComponents/ShiftFilter.vue";
import reportModel from "@/models/report.model";

@Component({
	components: {
		ShiftFilter,
		Circle2,
	},
})
class AnalyticalTransferReport extends Vue {
	shiftFilter: Record<string, any> = {};
	fileDownloading = false;

	updateFilter(filter: any) {
		this.shiftFilter = filter;
	}

	async getReport() {
		if (!this.validateForm()) {
			return;
		}

		this.fileDownloading = true;
		try {
			const reportBlob = await reportModel.getAnalyticalTransferReport({
				sectorId: this.shiftFilter?.sector,
				specialtyId: this.shiftFilter['sector.specialty'],
				startDateTime: this.shiftFilter.startDateTime,
				professionalUserId: this.shiftFilter?.professionalUser,
				unitId: this.shiftFilter.unit,
			});
			fileDownload(reportBlob, 'relatorio-repasse-analitico.xlsx');
		} catch (error) {
			this.$toasted.error((error as any).friendlyMessage || 'Não foi possível gerar o relatório. Tente novamente.');
			console.error(error);
		} finally {
			this.fileDownloading = false;
		}
	}

	validateForm(): boolean {
		if (this.shiftFilter && !this.shiftFilter.unit) {
			this.$toasted.error('É necessário selecionar uma unidade para gerar o relatório');
			return false;
		}
		return true;
	}
}

export default AnalyticalTransferReport;
